import { createFileRoute } from "@tanstack/react-router";

import { EposDisplay } from "@workspace/venue-management-staff-terminal/epos";
import {
	DeviceSelection,
	useKioskContext,
} from "@workspace/venue-management-staff-terminal/kiosk";

import { PageLoading } from "@/components/page-loading";

export const Route = createFileRoute(
	"/_auth/_dashboard/$tenant/venues/$venueId/epos/",
)({
	component: RouteComponent,
	pendingComponent: PageLoading,
});

function RouteComponent() {
	const { deviceId, setDeviceId, tenant, venueId } = useKioskContext();

	if (!deviceId) {
		return (
			<DeviceSelection
				tenant={tenant}
				venueId={venueId}
				onSelect={setDeviceId}
			/>
		);
	}

	return (
		<>
			<EposDisplay active />
		</>
	);
}
